import { NavigationServiceInterface } from "etl/core";
import { NavigateFunction, Location } from "react-router";

class NavigationService implements NavigationServiceInterface {
    private navigateFunction: NavigateFunction | null = null;
    public location: Location | null = null;

    // Méthode pour initialiser le service avec les hooks de react-router
    init(navigate: NavigateFunction, location: Location) {
        this.navigateFunction = navigate;
        this.location = location;
    }

    navigate(path: string, options?: { replace?: boolean; state?: any }) {
        if (!this.navigateFunction) {
            console.warn("Navigation service not initialized. Make sure to call init() first.");
            return;
        }
        this.navigateFunction(path, options);
    }

    goBack() {
        if (!this.navigateFunction) {
            console.warn("Navigation service not initialized. Make sure to call init() first.");
            return;
        }
        this.navigateFunction(-1);
    }

    goForward() {
        if (!this.navigateFunction) {
            console.warn("Navigation service not initialized. Make sure to call init() first.");
            return;
        }
        this.navigateFunction(1);
    }

    getLocation() {
        return this.location;
    }
}

// Exportez une instance singleton
export const navigationService = new NavigationService();
